import { Component } from '@angular/core';

@Component({
  selector: 'em-not-found',
  templateUrl: './not-found.component.html',
  standalone: false,
})
export class NotFoundComponent {}
